export default __webpack_public_path__ + "pause.svg";